import { api } from '../api';
import { Sheet } from '../../entities/Sheet';

export const getSheets = async () => {
  const { data } = await api.get('/sheets');
  const sheets: Sheet[] = data;

  return sheets;
};
